module.exports = __webpack_public_path__ + "67e16a0e69984af90c9a30f25d63d7e3.svg";